<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/117LIHs/tc-custom/9781467449588.jpg?1730409816245" alt="This image is the cover for the book The Story of Latino Protestants in the United States"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Story of Latino Protestants in the United States
      </h1>
      <p class="bookDescription body article font2">
        <i>The first major historical overview of one of America's most vibrant Christian movements</i><br/><br/> This groundbreaking book by Juan Francisco Martínez provides a broad historical overview of Latino Protestantism in the United States from the early nineteenth century to the present.<br/><br/> Beginning with a description of the diverse Latino Protestant community and a summary of his own historiographical approach, Martínez then examines six major periods in the history of American Latino Protestantism, paying special attention to key social, political, and religious issues—including immigration policies, migration patterns, enculturation and assimilation, and others—that framed its development and diversification during each period. He concludes by outlining the challenges currently facing Latino Protestants in the United States and considering what Latino Protestantism might look like in the future.<br/><br/> Offering vital insights into key leaders, eras, and trends in Latino Protestantism, Martínez's work will prove an invaluable resource for all who are seeking to understand this rapidly growing US demographic.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Juan Francisco Martinez
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Juan Francisco Mart&iacute;nez</B>&#160;is professor of Hispanic studies and pastoral leadership at Fuller Theological Seminary. A fifth-generation American Latino Protestant himself, he is a recognized expert on the history of the movement.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2440c874